import React from "react";
import ReactDOM from "react-dom/client";

import { DesignSystemProvider } from "@ospra/design-system";

import App from "./App";
import { QueryProvider } from "./lib/queryProvider";
import "./index.css";

const rootElement = document.getElementById("root");
if (rootElement) {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <DesignSystemProvider>
        <QueryProvider>
          <App />
        </QueryProvider>
      </DesignSystemProvider>
    </React.StrictMode>
  );
}
